export function getCookie(name) {
  if (typeof document === 'undefined') return null;
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return decodeURIComponent(parts.pop().split(';').shift());
  return null;
}

export function getAuthToken() {
  return getCookie('token');
}

export function getUserRoles() {
  const raw = getCookie('roles');
  try {
    return raw ? JSON.parse(raw) : [];
  } catch (e) {
    return [];
  }
}

export function isAuthenticated() {
  return !!getAuthToken();
}

export function clearCookie(name) {
  if (typeof document === 'undefined') return;
  const secure =
    typeof window !== 'undefined' && window.location.protocol === 'https:'
      ? '; Secure'
      : '';
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; SameSite=Strict${secure}`;
}

export function clearAuthSession() {
  ['token', 'roles', 'userId', 'username'].forEach(clearCookie);
  if (typeof sessionStorage !== 'undefined') {
    sessionStorage.removeItem('selectedLocationBoilerModuleEnabled');
  }
}

export function logout() {
  clearAuthSession();
  window.location.href = '/login';
}

/**
 * Sets a client-side cookie.
 * Prefer server-set, HttpOnly cookies for tokens to prevent JavaScript access.
 */
export function setCookie(name, value, days) {
    if (typeof document === 'undefined') return;
    let expires = "";
    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = "; expires=" + date.toUTCString();
    }
    const secure =
      typeof window !== 'undefined' && window.location.protocol === 'https:'
        ? '; Secure'
        : '';
    document.cookie = `${name}=${encodeURIComponent(value || "")}${expires}; path=/; SameSite=Strict${secure}`;
  }
